import { useState } from 'react'
import Header from './Header'
import Footer from './Footer'

function AccordionItem({ title, children, isOpen, onClick, whatsappMsg }) {
  const waLink = `https://wa.me/+5491124089830?text=${encodeURIComponent(whatsappMsg)}`
  return (
    <div className="accordion-item-custom">
      <button
        className={`accordion-header-custom ${isOpen ? 'active' : ''}`}
        onClick={onClick}
        aria-expanded={isOpen}
      >
        <span>{title}</span>
        <i className={`bi ${isOpen ? 'bi-chevron-up' : 'bi-chevron-down'}`} />
      </button>
      <div className={`accordion-body-custom ${isOpen ? 'open' : ''}`}>
        <div className="accordion-content-custom">
          {children}
          <div style={{marginTop: '15px'}}>
            <a href={waLink} className="cta-button cta-button-sm">Consultar por este servicio</a>
          </div>
        </div>
      </div>
    </div>
  )
}

function Gestoria() {
  const title = 'Gestoría'
  const [openIndex, setOpenIndex] = useState(null)

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <>
      <Header/>
      <main id="main">
        <section id="breadcrumbs" className="breadcrumbs">
          <div className="container">
            <ol>
              <li><a href="/">Inicio</a></li>
              <li>{title}</li>
            </ol>
            <h3>{title}</h3>
            <p className="justified-text">Servicio de gestoría legal a tu medida. Redacción, negociación y revisión de contratos, apostillas de documentos, informes registrales ante RPI  (Registro de la Propiedad Inmueble) y RPA (Registro de Propiedad Automotor), rectificaciones de documentos en CABA y todo tipo de trámites administrativos para que vos no pierdas tiempo y te ocupes de lo importante.</p>
            <div className="accordion-custom" style={{marginTop: '30px'}}>
              <AccordionItem
                title="Redacción y revisión de contratos privados"
                isOpen={openIndex === 0}
                onClick={() => toggle(0)}
                whatsappMsg="Hola, quiero consultar por redacción o revisión de un contrato privado"
              >
                <p>Redactamos y revisamos <strong>contratos de locación, compraventa, servicios, comodato</strong> y cualquier otro acuerdo entre partes. ¿Te mandaron un contrato y no sabés si te conviene firmarlo? Nosotros lo revisamos, te explicamos cada cláusula y lo negociamos por vos. Si necesitás armar uno, lo hacemos a medida protegiendo tus intereses.</p>
              </AccordionItem>

              <AccordionItem
                title="Apostillado de documentos públicos"
                isOpen={openIndex === 1}
                onClick={() => toggle(1)}
                whatsappMsg="Hola, quiero consultar por apostillado de documentos públicos"
              >
                <p>Gestionamos el apostillado de tus documentos públicos (partidas, poderes, certificados, sentencias) para que tengan validez internacional según el Convenio de La Haya. Nos encargamos del trámite completo ante el Colegio de Escribanos o el Ministerio de Relaciones Exteriores según corresponda.</p>
              </AccordionItem>

              <AccordionItem
                title="Búsqueda y actualización de documentos públicos"
                isOpen={openIndex === 2}
                onClick={() => toggle(2)}
                whatsappMsg="Hola, quiero consultar por búsqueda o actualización de documentos públicos"
              >
                <p>Realizamos la búsqueda y obtención de partidas de nacimiento, matrimonio y defunción en registros civiles, así como su actualización cuando la documentación tiene más de 6 meses de emitida.</p>
              </AccordionItem>

              <AccordionItem
                title="Rectificaciones de documentación del Registro Civil de CABA"
                isOpen={openIndex === 3}
                onClick={() => toggle(3)}
                whatsappMsg="Hola, quiero consultar por rectificación de documentación del Registro Civil de CABA"
              >
                <p>Tramitamos la corrección de errores en actas del Registro Civil de la Ciudad Autónoma de Buenos Aires: errores en nombres, apellidos, fechas, datos de los padres u otras inconsistencias que puedan trabar tus trámites legales o administrativos. Realizamos rectificaciones tanto por <strong>vía administrativa como judicial</strong>.</p>
              </AccordionItem>

              <AccordionItem
                title="Inscripción de dominio web"
                isOpen={openIndex === 4}
                onClick={() => toggle(4)}
                whatsappMsg="Hola, quiero consultar por inscripción de dominio web"
              >
                <p>Gestionamos la inscripción y registro de dominios .com.ar ante NIC Argentina, así como transferencias de titularidad y renovaciones. Asegurá tu presencia online con el dominio correcto para tu marca o emprendimiento.</p>
              </AccordionItem>

              <AccordionItem
                title="Informes del Registro de la Propiedad Inmueble de CABA"
                isOpen={openIndex === 5}
                onClick={() => toggle(5)}
                whatsappMsg="Hola, quiero consultar por informes del Registro de la Propiedad Inmueble de CABA"
              >
                <p>Solicitamos informes ante el Registro de la Propiedad Inmueble de la Ciudad de Buenos Aires:</p>
                <ul>
                  <li><i className="bi bi-check-circle" /> <strong>Informe de dominio</strong> — Informa quién es el dueño y si tiene cargas como embargos o hipotecas. Necesitás el número de matrícula (si no lo tenés, primero pedinos el <strong>Informe de matrícula y titular</strong>). Disponible en trámite <strong>común (dentro de los 4 días)</strong>, <strong>urgente (dentro de los 2 días)</strong> y <strong>exprés (al día hábil siguiente)</strong>.</li>
                  <li><i className="bi bi-check-circle" /> <strong>Informe de inhibiciones</strong> — Informa si una persona humana o jurídica tiene inhibiciones registradas en CABA. Disponible en trámite <strong>común (dentro de los 4 días)</strong>, <strong>urgente (dentro de los 2 días)</strong> y <strong>exprés (al día hábil siguiente)</strong>.</li>
                  <li><i className="bi bi-check-circle" /> <strong>Buscá propiedades por persona</strong> — Con el nombre y DNI de una persona (o razón social de una empresa) podés ver qué propiedades tiene en CABA. Disponible en trámite <strong>común (dentro de los 2 días)</strong> y <strong>urgente (al día hábil siguiente)</strong>.</li>
                  <li><i className="bi bi-check-circle" /> <strong>Informe de matrícula y titular</strong> — Con la dirección exacta del inmueble obtenés la matrícula y el nombre del titular. Solo trámite <strong>común (dentro de los 4 días)</strong>, no hay modalidad urgente.</li>
                  <li><i className="bi bi-check-circle" /> <strong>Informe de frecuencia</strong> — Muestra cuántas veces se solicitó el <strong>Informe de dominio</strong> sobre un inmueble. Permite saber cuántas veces se utilizó como garantía dicho inmueble. <strong>Entrega en el día</strong>.</li>
                  <li><i className="bi bi-check-circle" /> <strong>Informe completo del inmueble </strong> — Combina el <strong>Informe de matrícula y titular</strong> y el  <strong>Informe de dominio</strong> en un solo trámite: obtenés la matrícula, el titular y el estado registral. Solo trámite <strong>común</strong>, no hay modalidad urgente. Demora aproximadamente <strong>8 días hábiles</strong>.</li>
                </ul>
              </AccordionItem>

              <AccordionItem
                title="Informe de dominio del Registro Automotor"
                isOpen={openIndex === 6}
                onClick={() => toggle(6)}
                whatsappMsg="Hola, quiero consultar por informe de dominio del Registro Automotor"
              >
                <p>Solicitamos el informe de dominio ante el Registro Nacional de la Propiedad del Automotor (DNRPA), que detalla la titularidad del vehículo, prendas, embargos, inhibiciones y cualquier otra afectación registral. Indispensable antes de comprar o vender un vehículo usado.</p>
              </AccordionItem>
            </div>

            <div className="text-center" style={{marginTop: '40px'}}>
              <p><strong>¿Necesitás resolver un trámite?</strong> Escribinos y te orientamos.</p>
              <a href="https://wa.me/+5491124089830?text=Hola%2C%20necesito%20asesoramiento%20sobre%20gestor%C3%ADa" className="cta-button">Hablemos de tu trámite</a>
            </div>
          </div>
        </section>
      </main>
      <Footer/>

      <style>{`
        .accordion-custom {
          max-width: 800px;
          margin: 0 auto;
        }
        .accordion-item-custom {
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          margin-bottom: 12px;
          overflow: hidden;
          transition: box-shadow 0.3s ease;
        }
        .accordion-item-custom:hover {
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
        }
        .accordion-header-custom {
          width: 100%;
          padding: 18px 24px;
          background: #fff;
          border: none;
          cursor: pointer;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 1.05rem;
          font-weight: 600;
          color: #2c2c2c;
          transition: background 0.2s ease;
        }
        .accordion-header-custom:hover {
          background: #fafafa;
        }
        .accordion-header-custom.active {
          background: #b41e1e;
          color: #fff;
        }
        .accordion-header-custom.active i {
          color: #fff;
        }
        .accordion-header-custom i {
          font-size: 1.1rem;
          color: #b41e1e;
          transition: transform 0.3s ease;
        }
        .accordion-body-custom {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.4s ease;
        }
        .accordion-body-custom.open {
          max-height: 600px;
        }
        .accordion-content-custom {
          padding: 20px 24px;
          border-top: 1px solid #eee;
        }
        .accordion-content-custom p {
          font-size: 0.98rem;
          color: #555;
          line-height: 1.7;
          text-align: justify;
          margin-bottom: 10px;
        }
        .accordion-content-custom ul {
          list-style: none;
          padding: 0;
        }
        .accordion-content-custom ul li {
          padding: 6px 0;
          font-size: 0.95rem;
          color: #555;
        }
        .accordion-content-custom ul li i {
          color: #b41e1e;
          margin-right: 8px;
        }
        .cta-button-sm {
          font-size: 0.85rem;
          padding: 10px 20px;
        }
      `}</style>
    </>
  )
}

export default Gestoria;
